import { EventIds } from 'constants/eventIds';
import { useState } from 'react';
import useMountEffect from 'hooks/useMountEffect';
import api, { isNetworkError } from 'api';
import { CONFIG } from 'utils/config';
import { log } from 'utils';

export const useGetIsGDPR = () => {
    const [isGdpr, setIsGdpr] = useState(false);

    async function getGeolocation() {
        try {
            const response = await api.get<{ data: { isGdpr: boolean } }>(
                CONFIG.VITE_MS_GEOLOCATION,
            );

            setIsGdpr(!!response.data?.data?.isGdpr);
        } catch (error) {
            if (isNetworkError(error)) {
                log.warn(
                    'useGetIsGDPR network error',
                    EventIds.FailedToGetGeolocation,
                    error,
                );
            } else {
                log.error(
                    'useGetIsGDPR error',
                    EventIds.FailedToGetGeolocation,
                    error,
                );
            }
        }
    }

    useMountEffect(getGeolocation);

    return isGdpr;
};
